import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, FileText } from 'lucide-react';
import { brand, footer } from '../mock';

const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-[#16161d] px-6 py-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] text-[#6a6a74]">
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5 text-[#c99a2e] font-semibold">
            {footer.ecosystem}
            <ExternalLink className="h-3 w-3" />
          </span>
          <span className="text-[#4a4a54]">{footer.copyright}</span>
        </div>
        <div className="flex items-center gap-5">
          <span>{footer.note}</span>
          <span className="flex items-center gap-1 hover:text-[#c99a2e] cursor-pointer transition-colors">
            Disclaimer <FileText className="h-3 w-3" />
          </span>
          <Link to="/blog" className="hover:text-[#c99a2e] cursor-pointer transition-colors">Blog</Link>
          <span className="hover:text-[#c99a2e] cursor-pointer transition-colors">Support</span>
          <span className="text-[#4a4a54] font-mono">{brand.version}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
